import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugCarbamazepine} from "./TextDrugCarbamazepine"


export default function Carbamazepine() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
   
    <ButtonsText onClick={handleOpen} name='Carbamazepine' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Carbamazepine - PGx Recommendation"
        content={ <TextDrugCarbamazepine />}

        />

</>
)}